import React, { Component, Fragment } from "react";
import { curdActions } from "../../reduxCURD/actions";
import { getAppMockupsTypes } from "../../reduxRelated/actions/diagnosticsActions";
import { CRUDFunction } from "../../reduxCURD/container";
import ViewOutOfUse from "./viewOutOfUse/ViewOutOfUse";
import { languageService } from "../../Language/language.service";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import SvgIcon from "react-icons-kit";
import { getAllInspectableAssets } from "../../reduxRelated/actions/assetHelperAction";
import moment from "moment";
import { blueCardMethods } from "../BlueCardReport/BlueCardReportView/HelperMethods";
import { plus } from "react-icons-kit/icomoon/plus";
import TooltipContainer from "../../libraries/TooltipContainer";
import { ButtonCirclePlus } from "../Common/Buttons";
import ConfirmationDialog from "../../libraries/ConfirmationDialog";
import SpinnerLoader from "../Common/SpinnerLoader";
import { ToastService } from "../../utils/toastify";
import _ from "lodash";

class ReVAMPOutOfUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOutOfUse: null,
      assetId: null,
      oouEntriesList: [],
      oouEntriesListOnLoad: [],
      confirmationDialog: null,
      spinnerLoading: false,
    };
    this.getOOUData = this.getOOUData.bind(this);
    this.updateOOULookup = this.updateOOULookup.bind(this);
    this.handleOOULookupSave = this.handleOOULookupSave.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.isOOUSaveDisabled = this.isOOUSaveDisabled.bind(this);
  }
  componentDidMount() {
    if (this.props.match) {
      this.setState({ assetId: this.props.match.params.id });
    }
    this.props.getAllInspectableAssets(["unitId", "assetStates"]);
    this.props.getAppMockupsTypes("OutOfUseAsset");
  }

  getOOUData(id) {
    let { oouAssetLookups } = this.props;
    let selectedOutOfUse = null;
    let oouEntriesListToStore = [];
    if (oouAssetLookups) {
      let filtered = oouAssetLookups.find((e) => e.code === `OOU_${id}`);
      if (filtered) {
        selectedOutOfUse = filtered;
        oouEntriesListToStore = filtered.opt2;
      }
    }

    this.setState({ selectedOutOfUse: selectedOutOfUse, oouEntriesList: oouEntriesListToStore, spinnerLoading: false });
  }

  handleOOULookupSave() {
    this.openConfirmationDialog("Update out of use", "Are you sure you want to update out of use?", this.updateOOULookup, "Confirm", null);
  }

  updateOOULookup() {
    const { oouEntriesList, assetId, selectedOutOfUse } = this.state;
    const { updateReVAMPOutOfUseData } = this.props;

    let oouList = oouEntriesList
      .filter((e) => !e.nonEditable)
      .map((e) => ({
        ...(e.original ? { ...e } : {}),
        start: e.start,
        ...(e.status === "OPEN"
          ? {}
          : {
              end: e.end,
              status: e.status,
            }),
        showOnBlueCardCheck: e.showOnBlueCardCheck,
      }));

    let dbOOUList = ((selectedOutOfUse && selectedOutOfUse.opt2) || []).map((item) => ({
      id: item.id,
      start: item.start,
      end: item.end,
    }));

    updateReVAMPOutOfUseData &&
      updateReVAMPOutOfUseData(
        {
          oouList: oouList,
          dbOOUList: dbOOUList,
          assetId: assetId,
        },
        "manualOutOfUse",
      );

    this.setState({
      confirmationDialog: null,
      oouEntriesList: [],
    });
  }
  isApp = () => localStorage.getItem("source");

  openConfirmationDialog(title, message, confirmCallback, action, data) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
          additionalInfo={data}
        />
      ),
    });
  }
  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }

  isOOUSaveDisabled() {
    const editableEntryDoesNotExist = this.state.oouEntriesList.filter((e) => !e.nonEditable).length === 0;
    const originalOpenEntryExists = this.state.oouEntriesList.find((e) => e.original && !e.end && !e.nonEditable) || {};
    const openEntryOnLoad = this.state.oouEntriesListOnLoad.find((e) => e.id === originalOpenEntryExists.id);

    const openEntryIsNotChanged =
      originalOpenEntryExists &&
      openEntryOnLoad &&
      new Date(originalOpenEntryExists.end || new Date()).getTime() === new Date(openEntryOnLoad.end || new Date()).getTime() &&
      openEntryOnLoad.showOnBlueCardCheck === originalOpenEntryExists.showOnBlueCardCheck;

    return editableEntryDoesNotExist || openEntryIsNotChanged;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.diagnosticsActionType !== this.props.diagnosticsActionType &&
      this.props.diagnosticsActionType === "GET_OOU_LOOKUPS_SUCCESS"
    ) {
      this.getOOUData(this.state.assetId);
    }

    if (
      prevProps.diagnosticsActionType !== this.props.diagnosticsActionType &&
      this.props.diagnosticsActionType === "GET_OOU_LOOKUPS_REQUEST"
    ) {
      this.setState({ spinnerLoading: true });
    }

    if (
      prevProps.diagnosticsActionType !== this.props.diagnosticsActionType &&
      this.props.diagnosticsActionType === "GET_OOU_LOOKUPS_FAILURE"
    ) {
      this.setState({ spinnerLoading: false });
    }

    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "REVAMPOUTOFUSEDATA_UPDATE_SUCCESS") {
      ToastService.Success("Out of use updated successfully", "");
      this.props.getAppMockupsTypes("OutOfUseAsset");
    }

    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "REVAMPOUTOFUSEDATA_UPDATE_FAILURE") {
      ToastService.Error("Out of use update error.", "Please try again after refreshing");
      this.props.getAppMockupsTypes("OutOfUseAsset");
    }
    if (
      prevProps.assetHelperActionType !== this.props.assetHelperActionType &&
      this.props.assetHelperActionType === "GET_ALLINSPECTABLE_ASSETS_SUCCESS"
    ) {
      let selectedAsset = this.props.allInspectableUserAssets.assets.find((e) => e._id == this.state.assetId);
      if (selectedAsset) this.setState({ selectedAsset: selectedAsset });
    }
  }

  render() {
    return (
      <Fragment>
        {this.state.confirmationDialog}
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />
        <Fragment>
          <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
            <div
              className="report-arrow"
              style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
              onClick={(e) => {
                this.props.history.goBack();
              }}
            >
              <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                {languageService("Back")}
              </span>
              <SvgIcon icon={arrowLeft} size={24} />
            </div>
          </div>

          {
            <ViewOutOfUse
              OutOfUse={this.state.selectedOutOfUse}
              credit={getAvailableCredit(this.state.selectedOutOfUse)}
              selectedAsset={this.state.selectedAsset}
              assetId={this.state.assetId}
              userList={this.state.userList}
              assetDbOOU={this.props.oouAssetLookups}
              OOUOnLoadState={(oouList) => {
                this.setState({ oouEntriesListOnLoad: oouList });
              }}
              updateOOuEntries={(oouList) => {
                this.setState({ oouEntriesList: oouList });
              }}
              handleOOULookupSave={this.handleOOULookupSave}
              saveDisabled={this.isOOUSaveDisabled()}
              renderActions={(addNewRow) => (
                <div style={{ width: "fit-content", paddingBottom: "10px" }}>
                  <TooltipContainer tooltipText={languageService("Add New Entry")} placement={"top"}>
                    <ButtonCirclePlus
                      handleClick={addNewRow}
                      iconSize={30}
                      icon={plus}
                      customClassName={"road"}
                      backgroundColor="#e3e9ef"
                      margin="5px 0px 0px 0px"
                      borderRadius="50%"
                      hoverBackgroundColor="#e3e2ef"
                      hoverBorder="0px"
                      activeBorder="3px solid #e3e2ef"
                      iconStyle={{
                        color: "#c4d4e4",
                        background: "var(--fifth)",
                        borderRadius: "50%",
                        border: "3px solid ",
                      }}
                    />
                  </TooltipContainer>
                </div>
              )}
            />
          }
        </Fragment>
      </Fragment>
    );
    // return
  }
}

function getAvailableCredit(oouEntry) {
  if (!oouEntry) return 0;
  const availableEntries = oouEntry.opt2.filter((entry) => entry.status === "Available");
  if (availableEntries.length === 0) return 0;

  const credit = availableEntries.reduce((sum, entry) => {
    let diff = blueCardMethods.calculateOOUDays(entry.start, entry.end);
    if (diff >= 30) sum += diff;
    return sum;
  }, 0);

  return credit;
}

let variableList = {
  diagnosticsReducer: {
    oouAssetLookups: [],
  },
  assetHelperReducer: {
    allInspectableUserAssets: [],
  },
};
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    getAppMockupsTypes,
    getAllInspectableAssets,
  },
};
const ReVAMPOutOfUseContainer = CRUDFunction(
  ReVAMPOutOfUse,
  "ReVAMPOutOfUseData",
  actionOptions,
  variableList,
  ["diagnosticsReducer", "assetHelperReducer"],
  "blueCard",
);
export default ReVAMPOutOfUseContainer;



// WEBPACK FOOTER //
// ./src/components/ReVAMPOutOfUse/ReVAMPOutOfUse.jsx